/** Agent glossary limits (M29 WP-GLOSSARY, LNG-001). Mirrors `backend/app/core/constants/glossary.py` (checked by `backend/tests/core/test_glossary_mirror.py`). */

/** `GlossaryLocale` values, in the order the backend declares them. */
export const GLOSSARY_LOCALE_VALUES = ["en", "fil", "taglish", "any"] as const;

/** Longest and shortest term (and synonym), in characters. */
export const GLOSSARY_TERM_MIN = 1 as const;
export const GLOSSARY_TERM_MAX = 80 as const;

/** Most synonyms one term keeps. */
export const GLOSSARY_SYNONYMS_MAX = 20 as const;

/** Most terms a workspace keeps. */
export const GLOSSARY_TERMS_MAX = 2000 as const;

/** The range of an agent's cap on a reply, in words. */
export const REPLY_MAX_WORDS_MIN = 20 as const;
export const REPLY_MAX_WORDS_MAX = 400 as const;
